<script>
const BUTTON_TYPES = Object.freeze({
  PRIMARY: "primary",
  TRANSPARENT: "transparent",
  LIGHT_GRAY: "light-gray",
  SLATE_GRAY: "slate-gray",
  SLATE_DARK: "slate-dark",
  WHITE: "white",
  BLUE: "blue",
  BLUE_TRANSPARENT: "blue-transparent",
  RED: "red",
});
</script>

<script setup>
defineEmits(["click"]);

defineProps({
  buttonType: {
    type: String,
    default: BUTTON_TYPES.PRIMARY,
    validator: (prop) => Object.values(BUTTON_TYPES).includes(prop),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hasFontBold: {
    type: Boolean,
    default: false,
  },
  hasFontSemiBold: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <BButton
    @click="(event) => $emit('click', event)"
    class="rounded-3 font-size-xs"
    :disabled="disabled"
    :class="{
      [buttonType]: true,
      'fw-bold': hasFontBold,
      'fw-semibold': hasFontSemiBold,
      disabled,
    }"
    :type="type"
  >
    <slot />
  </BButton>
</template>

<style scoped lang="scss">
.btn {
  border-radius: 8px;
  color: white;
  padding: 8px 12px;

  &.primary {
    background-color: $bluish-gray-800;
    border: 1px solid $bluish-gray-800;
  }

  &.transparent {
    background: transparent;
    border: 1px solid $neutral-200;
    color: $neutral-400;

    &.disabled {
      opacity: 0.5;
      background: transparent;
    }
  }

  &.slate-gray {
    background-color: $bluish-gray-950;
    border: 1px solid $bluish-gray-950;
  }

  &.slate-dark {
    background-color: $bluish-gray-1000;
    border: 1px solid $bluish-gray-1000;
  }

  &.light-gray {
    background-color: $bluish-gray-400;
    color: $bluish-gray-950;
    border: 1px solid $bluish-gray-400;
  }

  &.white {
    background-color: white;
    color: $bluish-gray-1000;
    border: 1px solid $neutral-200;

    &:hover {
      background: $neutral-100;
    }
  }

  &.blue {
    background-color: var(--primary-250);
    border: none;

    &:hover {
      background: var(--primary-300);
    }
  }

  &.blue-transparent {
    background-color: $neutral-0;
    border: 1px solid var(--primary-150);
    color: var(--primary-250);

    &:hover {
      background: var(--primary-0);
    }
  }

  &.red {
    background-color: $red-200;
    color: $neutral-200;
    border: none;

    &:hover {
      background: $red-250;
    }
  }

  &.disabled {
    background: $neutral-300;
    color: $neutral-0;
    pointer-events: none;
  }
}
</style>
